import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Form, Button } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Select from "react-select"
import { getCardsByMonth } from '../../actions/cardsActions'
import MonthPickerInput from 'react-month-picker-input'
import 'react-month-picker-input/dist/react-month-picker-input.css'
import FileSaver from 'file-saver'
import XLSX from 'sheetjs-style'
import Swal from 'sweetalert2'

export default function Reports() { 
    const { t } = useTranslation()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [typeReport, setTypeReport] = useState({options: [  
        {value: 'machinery', label: t('administrative.machinery')},
        {value: "workers", label: t('administrative.workers')},
        {value: "fitosanitary", label: t('administrative.fitosanitary')}
    ], selected: null})

    const [disableFirstPath, setDisableFirstPath] = useState(false)
    const [disableSecondPath, setDisableSecondPath] = useState(false)
    const [monthReport, setMonthReport] = useState('')
    const [disableDownload, setDisableDownload] = useState(true)
    const [hiddenError, setHiddenError] = useState(true)
    
    const {cards} = useSelector((state) => state.cards)

    useEffect(()=>{
        if(cards !== null && cards.length > 0){
            setDisableDownload(false)
            setHiddenError(true)
        }else{
            setDisableDownload(true)
            setHiddenError(false)
        }
    }, [cards])

    useEffect(()=>{
        if(disableFirstPath !== false && disableSecondPath !== false){
            dispatch(getCardsByMonth(monthReport))
        }
    }, [disableFirstPath, disableSecondPath, monthReport, dispatch])

    const changeTypeReport = (target) => {
        setTypeReport({
            ...typeReport, 
            selected: {value: target.value, label: target.label}
        })

        setDisableFirstPath(true)
    }

    const changeMonth = (selectedMonth, selectedYear) => {
        if(selectedMonth+'-'+selectedYear !== '-'){

            if(selectedMonth < 10){
                selectedMonth = '01-0'+selectedMonth
            }else{
                selectedMonth = '01-'+selectedMonth
            }

            setMonthReport(selectedMonth+'-'+selectedYear)
            setDisableSecondPath(true)
        }
    }

    const downloadReport = (target) => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset-UTF-8'
        const fileExtension = '.xlsx'

        let dataExcel = []
        let maxWidth = []

        if(typeReport.selected.value === 'machinery'){
            cards?.map((card) => {
                // Entrada
                const utcDate1 = new Date(card?.in)
                const currentYear1 = utcDate1.getUTCFullYear()
                const summerTimeStart1 = new Date(currentYear1, 2, 26)
                const summerTimeEnd1 = new Date(currentYear1, 9, 29)

                const isSummerTime1 = utcDate1 >= summerTimeStart1 && utcDate1 < summerTimeEnd1;
                const madridOffsetWinter1 = 60; // GMT+1
                const madridOffsetSummer1 = 120; // GMT+2

                const madridTimestamp1 = utcDate1.getTime() + (isSummerTime1 ? madridOffsetSummer1 : madridOffsetWinter1) * 60 * 1000

                const madridDate1 = new Date(madridTimestamp1)

                const entrada = madridDate1.toISOString()

                // Salida
                const utcDate2 = new Date(card?.out)
                const currentYear2 = utcDate2.getUTCFullYear()
                const summerTimeStart2 = new Date(currentYear2, 2, 26)
                const summerTimeEnd2 = new Date(currentYear2, 9, 29)

                const isSummerTime2 = utcDate2 >= summerTimeStart2 && utcDate2 < summerTimeEnd2;
                const madridOffsetWinter2 = 60; // GMT+1
                const madridOffsetSummer2 = 120; // GMT+2

                const madridTimestamp2 = utcDate2.getTime() + (isSummerTime2 ? madridOffsetSummer2 : madridOffsetWinter2) * 60 * 1000

                const madridDate2 = new Date(madridTimestamp2)

                const salida = madridDate2.toISOString()

                let minutesThisCard = ''
                let miliseconds = new Date(salida) - new Date(entrada)
                let minutes = Math.floor((miliseconds / (1000 * 60)) % 60)
                let hours = Math.floor((miliseconds / (1000 * 60 * 60)) % 24)
            
                hours = (hours < 10) ? hours : hours
                minutes = (minutes < 10) ? "0" + minutes : minutes
                minutesThisCard = hours + ":" + minutes

                console.log(card)
                card.approved && card.machinery && card.machinery !== 'null' && card.machinery !== 'undefined'
                ?
                    <>
                        {maxWidth = [8, 14, 0, 14, 14, 14, 14, 10, 0, 0, 0, 0]}
                        {dataExcel.push({
                            'Tractor': card?.machinery?.name,
                            'Fecha': (entrada?.substr(8,2)+'/'+entrada?.substr(5,2)+'/'+entrada?.substr(0,4)).trim(),
                            'Tractorista': card?.user?.firstname+' '+card?.user?.lastname,
                            'Combustible': card?.litres_gasoil ? card?.litres_gasoil : 0,
                            'Urea': card?.litres_urea ? card.litres_urea : 0,
                            'Aceite motor': card?.litres_engine_oil ? card.litres_engine_oil : 0,
                            'Aceite hid': card?.litres_hydraulic_oil ? card.litres_hydraulic_oil : 0,
                            // 'Anticongelante': card?.litres_antifreeze ? card.litres_antifreeze : 0,
                            'Grasa': card?.litres_grease ? card.litres_grease : 0,
                            'Horas': minutesThisCard,
                            //'Campaña': card?.campaign?.description,
                            'Cultivo': card?.crop?.name,
                            'Trabajo': card?.labor?.name,
                            'Finca': card?.plot?.farm?.name
                        })}

                        {card?.machinery?.name?.length > maxWidth[0] ? maxWidth[0] = card?.machinery?.name?.length : <></>}
                        {(card?.user?.firstname+' '+card?.user?.lastname).length > maxWidth[2] ? maxWidth[2] = (card?.user?.firstname+' '+card?.user?.lastname).length : <></>}
                        {/* {card?.campaign?.description?.length > maxWidth[8] ? maxWidth[8] = card?.campaign?.description?.length : <></>} */}
                        {card?.crop?.name?.length > maxWidth[9] ? maxWidth[9] = card?.crop?.name?.length : <></>}
                        {card?.labor?.name?.length > maxWidth[10] ? maxWidth[10] = card?.labor?.name?.length : <></>}
                        {card?.plot?.farm?.name?.length > maxWidth[11] ? maxWidth[11] = card?.plot?.farm?.name?.length : <></>}
                    </>
                :
                    <></>

                return true
            })
        }
        if(typeReport.selected.value === 'workers'){
            cards?.map((card) => {
                // Entrada
                const utcDate1 = new Date(card?.in)
                const currentYear1 = utcDate1.getUTCFullYear()
                const summerTimeStart1 = new Date(currentYear1, 2, 26)
                const summerTimeEnd1 = new Date(currentYear1, 9, 29)

                const isSummerTime1 = utcDate1 >= summerTimeStart1 && utcDate1 < summerTimeEnd1;
                const madridOffsetWinter1 = 60; // GMT+1
                const madridOffsetSummer1 = 120; // GMT+2

                const madridTimestamp1 = utcDate1.getTime() + (isSummerTime1 ? madridOffsetSummer1 : madridOffsetWinter1) * 60 * 1000

                const madridDate1 = new Date(madridTimestamp1)

                const entrada = madridDate1.toISOString()

                // Salida
                const utcDate2 = new Date(card?.out)
                const currentYear2 = utcDate2.getUTCFullYear()
                const summerTimeStart2 = new Date(currentYear2, 2, 26)
                const summerTimeEnd2 = new Date(currentYear2, 9, 29)

                const isSummerTime2 = utcDate2 >= summerTimeStart2 && utcDate2 < summerTimeEnd2;
                const madridOffsetWinter2 = 60; // GMT+1
                const madridOffsetSummer2 = 120; // GMT+2

                const madridTimestamp2 = utcDate2.getTime() + (isSummerTime2 ? madridOffsetSummer2 : madridOffsetWinter2) * 60 * 1000

                const madridDate2 = new Date(madridTimestamp2)

                const salida = madridDate2.toISOString()
                
                let minutesThisCard = '00:00:00'
                let minutesextraThisCard = '00:00:00'

                let miliseconds = new Date(salida) - new Date(entrada)
                let seconds = Math.floor((miliseconds / (1000)) % 60)
                let minutes = Math.floor((miliseconds / (1000 * 60)) % 60)
                let hours = Math.floor((miliseconds / (1000 * 60 * 60)) % 24)
                
                seconds = (seconds < 10) ? "0" + seconds : seconds
                minutes = (minutes < 10) ? "0" + minutes : minutes
                minutesThisCard = hours + ":" + minutes + ":" + seconds
                
                if(card.extratimetype !== undefined){
                    if(card.extratimetype === 'extra'){
                        let secondsextra = Math.floor((card.extratime / (1000)) % 60)
                        let minutesextra = Math.floor((card.extratime / (1000 * 60)) % 60)
                        let hoursextra = Math.floor((card.extratime / (1000 * 60 * 60)))

                        secondsextra = (secondsextra < 10) ? "0" + secondsextra : secondsextra
                        minutesextra = (minutesextra < 10) ? "0" + minutesextra : minutesextra
                        minutesextraThisCard = hoursextra + ":" + minutesextra + ":" + secondsextra
                    }
                    if(card.extratimetype === 'nocount'){
                        minutesextraThisCard = '00:00:00'
                    }
                }

                if(minutesextraThisCard === '00:00:00'){
                    minutesextraThisCard = 'No hay'
                }

                card.approved
                ?
                    <>
                        {maxWidth = [14, 0, 15, 15, 35, 35, 10, 20, 10, 10, 15]}
                        {dataExcel.push({
                            'Fecha': entrada?.substr(8,2)+'/'+entrada?.substr(5,2)+'/'+entrada?.substr(0,4),
                            'Trabajador': card?.user?.firstname+' '+card?.user?.lastname,
                            'Hora de entrada': entrada?.substr(11,8),
                            'Hora de salida': salida?.substr(11,8),
                            'Horas:Minutos:Segundos fichados': minutesThisCard,
                            'Horas:Minutos:Segundos especiales': minutesextraThisCard,
                            'Cultivo': card?.crop?.name,
                            'Trabajo': card?.labor?.name,
                            'Categoría': card?.user?.category,
                            'Origin': card?.user?.origen?.name,
                            'Centro trabajo': card?.plot?.farm?.origen?.name
                        })}

                        {card?.machinery?.name?.length > maxWidth[0] ? maxWidth[0] = card?.machinery?.name?.length : <></>}
                        {(card?.user?.firstname+' '+card?.user?.lastname).length > maxWidth[1] ? maxWidth[1] = (card?.user?.firstname+' '+card?.user?.lastname).length : <></>}
                        {card?.crop?.name?.length > maxWidth[6] ? maxWidth[6] = card?.crop?.name?.length : <></>}
                        {card?.labor?.name?.length > maxWidth[7] ? maxWidth[7] = card?.labor?.name?.length : <></>}
                        {card?.user?.category?.length > maxWidth[8] ? maxWidth[8] = card?.user?.category?.length : <></>}
                        {card?.user?.origen?.name?.length > maxWidth[9] ? maxWidth[9] = card?.user?.origen?.name?.length : <></>}
                        {card?.plot?.farm?.origen?.name?.length > maxWidth[10] ? maxWidth[10] = card?.plot?.farm?.origen?.name?.length : <></>}
                    </>
                :
                    <></>

                return true
            })
        }
        if(typeReport.selected.value === 'fitosanitary'){
            cards?.map((card) => {
                // Entrada
                const utcDate1 = new Date(card?.in)
                const currentYear1 = utcDate1.getUTCFullYear()
                const summerTimeStart1 = new Date(currentYear1, 2, 26)
                const summerTimeEnd1 = new Date(currentYear1, 9, 29)

                const isSummerTime1 = utcDate1 >= summerTimeStart1 && utcDate1 < summerTimeEnd1;
                const madridOffsetWinter1 = 60; // GMT+1
                const madridOffsetSummer1 = 120; // GMT+2

                const madridTimestamp1 = utcDate1.getTime() + (isSummerTime1 ? madridOffsetSummer1 : madridOffsetWinter1) * 60 * 1000

                const madridDate1 = new Date(madridTimestamp1)

                const entrada = madridDate1.toISOString()
                
                card.approved && (card.products.length > 0 || card.product_extra.length > 0)
                ?
                    <>
                        {maxWidth = [14, 14, 16, 14, 8]}
                        {card?.products?.map((product) => {
                            dataExcel.push({
                                'Fecha': (entrada?.substr(8,2)+'/'+entrada?.substr(5,2)+'/'+entrada?.substr(0,4)).trim(),
                                'Marca': product.product.name,
                                'Materia activa': product.product.matter,
                                'Gastado': product.quantity,
                                'Und': product.type
                            })
                            product?.product?.name?.length > maxWidth[1] ? maxWidth[1] = product?.product?.name?.length : <></>
                            product?.product?.matter?.length > maxWidth[2] ? maxWidth[2] = product?.product?.matter?.length : <></>
                            product?.quantity?.length > maxWidth[4] ? maxWidth[4] = product?.quantity?.length : <></>
                            product?.type?.length > maxWidth[5] ? maxWidth[5] = product?.type?.length : <></>

                            return true
                        })}
                        {card?.product_extra?.map((product) => {
                            dataExcel.push({
                                'Fecha': (entrada?.substr(8,2)+'/'+entrada?.substr(5,2)+'/'+entrada?.substr(0,4)).trim(),
                                'Marca': product.product,
                                'Materia activa': '',
                                'Gastado': product.quantity,
                                'Und': product.type
                            })
                            product?.product?.length > maxWidth[1] ? maxWidth[1] = product?.product?.length : <></>
                            product?.quantity?.length > maxWidth[4] ? maxWidth[4] = product?.quantity?.length : <></>
                            product?.type?.length > maxWidth[5] ? maxWidth[5] = product?.type?.length : <></>

                            return true
                        })}
                    </>
                :
                    <></>

                return true
            })
        }

        if(dataExcel.length > 0){
            let ws = XLSX.utils.json_to_sheet(dataExcel)

            let patronStyleIzq = {font:{ bold: true}, fill:{ patternType:"solid", fgColor:{ rgb: "00dce6f1" }, bgColor:{ rgb: "00dce6f1" }}, border: { top: { style: 'medium', color: { rgb: "00000000" } }, bottom: { style: 'medium', color: { rgb: "00000000" } }, left: { style: 'medium', color: { rgb: "00000000" } }}}
            let patronStyleCent = {font:{ bold: true}, fill:{ patternType:"solid", fgColor:{ rgb: "00dce6f1" }, bgColor:{ rgb: "00dce6f1" }}, border: { top: { style: 'medium', color: { rgb: "00000000" } }, bottom: { style: 'medium', color: { rgb: "00000000" } }, right: { style: 'thin', color: { rgb: "00000000" } }}}
            let patronStyleDer = {font:{ bold: true}, fill:{ patternType:"solid", fgColor:{ rgb: "00dce6f1" }, bgColor:{ rgb: "00dce6f1" }}, border: { top: { style: 'medium', color: { rgb: "00000000" } }, bottom: { style: 'medium', color: { rgb: "00000000" } }, right: { style: 'medium', color: { rgb: "00000000" } }}}

            if(typeReport.selected.value === 'machinery'){
                ws['A1'].s = patronStyleIzq
                ws['B1'].s = patronStyleCent
                ws['C1'].s = patronStyleCent
                ws['D1'].s = patronStyleCent
                ws['E1'].s = patronStyleCent
                ws['F1'].s = patronStyleCent
                ws['G1'].s = patronStyleCent
                ws['H1'].s = patronStyleCent
                ws['I1'].s = patronStyleCent
                ws['J1'].s = patronStyleCent
                ws['K1'].s = patronStyleCent
                ws['L1'].s = patronStyleDer
                ws['!cols'] = [{ width: maxWidth[0] },{ width: maxWidth[1] },{ width: maxWidth[2] },{ width: maxWidth[3] },{ width: maxWidth[4] },{ width: maxWidth[5] },{ width: maxWidth[6] },{ width: maxWidth[7] },{ width: maxWidth[8] },{ width: maxWidth[9] },{ width: maxWidth[10] },{ width: maxWidth[11] },{ width: maxWidth[12] },{ width: maxWidth[13] },{ width: maxWidth[14]}]
            }
            if(typeReport.selected.value === 'workers'){
                ws['A1'].s = patronStyleIzq
                ws['B1'].s = patronStyleCent
                ws['C1'].s = patronStyleCent
                ws['D1'].s = patronStyleCent
                ws['E1'].s = patronStyleCent
                ws['F1'].s = patronStyleCent
                ws['G1'].s = patronStyleCent
                ws['H1'].s = patronStyleCent
                ws['I1'].s = patronStyleCent
                ws['J1'].s = patronStyleCent
                ws['K1'].s = patronStyleDer
                ws['!cols'] = [{ width: maxWidth[0] },{ width: maxWidth[1] },{ width: maxWidth[2] },{ width: maxWidth[3] },{ width: maxWidth[4] },{ width: maxWidth[5] },{ width: maxWidth[6] },{ width: maxWidth[7] },{ width: maxWidth[8] }, { width: maxWidth[9] }, { width: maxWidth[10] }]
            }
            if(typeReport.selected.value === 'fitosanitary'){
                ws['A1'].s = patronStyleIzq
                ws['B1'].s = patronStyleCent
                ws['C1'].s = patronStyleCent
                ws['D1'].s = patronStyleCent
                ws['E1'].s = patronStyleDer
                ws['!cols'] = [{ width: maxWidth[0] },{ width: maxWidth[1] },{ width: maxWidth[2] },{ width: maxWidth[3] },{ width: maxWidth[4] },{ width: maxWidth[5] }]
            }

            const wb = {Sheets: {'Hoja 1': ws}, SheetNames: ['Hoja 1']}
            const excelBuffer = XLSX.write(wb, {bookType: 'xlsx', type: 'array'})
            const data = new Blob([excelBuffer], {type: fileType})
            FileSaver.saveAs(data, 'Informe' + typeReport.selected.label + fileExtension)
        }else{
            Swal.fire({
                showConfirmButton: true,
                icon: 'warning',
                text: t('administrative.nodata')
            })
        }
    }

    const goBack = () => {
        navigate('/administrative/dashboard')
    }

    return (
        <>
            <Container className='cuerpo'>
                <Row className="text-left custom-card-header">
                    <Row className="custom-card-buttom">
                        <Button className="btn btn-secondary mb-4 mx-auto" onClick={goBack}>
                            <i className="fas fa-arrow-circle-left"></i> {t('global.return')}
                        </Button>
                    </Row>
                    <h1>{t('administrative.managereports')}</h1>
                    <Form.Label className="form-label">{t('administrative.selectaction')}</Form.Label>
                    <br/><br/><br/>
                    <Row className="text-center my-3">
                        <Col>
                            <Form.Group className="my-3">
                                <Form.Label>{t('administrative.reportstype')}</Form.Label>
                                <Select
                                    onChange={changeTypeReport}
                                    name="typereport"
                                    placeholder={t('administrative.reportstype')}
                                    options={typeReport?.options}
                                    value={typeReport?.selected}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="my-3">
                                <Form.Label>{t('administrative.selectmonth')}</Form.Label>
                                {/* {-------------------------------------------------------------} */}
                                <MonthPickerInput
                                    lang='es'
                                    className='month-calendar'
                                    onChange={function(maskedValue, selectedYear, selectedMonth) {
                                        selectedMonth = selectedMonth+1

                                        changeMonth(selectedMonth++, selectedYear)
                                    }}
                                />
                                {/* {-------------------------------------------------------------} */}
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="text-center my-3">
                        <label className="text-warning" hidden={hiddenError}>* {t('administrative.thereisnotcards')} *</label>
                        <Button className="btn btn-secondary my-2 mx-auto" type="submit" onClick={downloadReport} disabled={disableDownload}><i className="far fa-file-excel"></i> {t('administrative.download')}</Button>
                    </Row>
                </Row>
            </Container>
        </>
    )
}


  
                
